import { CAMPAIGN, COMPLIANCE_DISCLOSURE, COPYRIGHT_LINE } from "@/lib/campaign";

/* SECTION 13 — FOOTER */
export const Footer = ({ disclosure = COMPLIANCE_DISCLOSURE }) => (
  <footer className="relative overflow-hidden hairline-t" style={{ background: "var(--background-deep)" }} data-testid="site-footer">
    {/* Debossed wordmark */}
    <p
      aria-hidden="true"
      className="font-display font-semibold text-white/[0.04] leading-none whitespace-nowrap select-none pointer-events-none text-center pt-12"
      style={{ fontSize: "13vw" }}
    >
      BENEFIT TO KEYS
    </p>

    <div className="max-w-6xl mx-auto px-5 md:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12 text-left">
      <div className="space-y-1.5 text-sm text-[rgba(255,255,255,0.75)]">
        <img
          src={CAMPAIGN.logo}
          alt="Kinsfolk Mortgage"
          className="h-9 w-auto mb-5"
          style={{ filter: "brightness(0) invert(1)" }}
          loading="lazy"
        />
        <p className="text-white font-medium">{CAMPAIGN.hostName}</p>
        <p>{CAMPAIGN.hostCompany}</p>
        <p className="font-mono text-xs">Individual NMLS #{CAMPAIGN.hostNmls}</p>
        <p className="font-mono text-xs">
          {CAMPAIGN.hostLegalCompany} · Company NMLS #{CAMPAIGN.companyNmls}
        </p>
        <p>Licensed in {CAMPAIGN.licensedIn}</p>
      </div>

      <div className="space-y-2 text-sm">
        <a href={`tel:+18137104602`} data-testid="footer-phone-link" className="block text-[rgba(255,255,255,0.75)] hover:text-[var(--accent)] transition-colors duration-200">
          {CAMPAIGN.phone}
        </a>
        <a href={`mailto:${CAMPAIGN.email}`} data-testid="footer-email-link" className="block text-[rgba(255,255,255,0.75)] hover:text-[var(--accent)] transition-colors duration-200 break-all">
          {CAMPAIGN.email}
        </a>
        <a href={CAMPAIGN.website} target="_blank" rel="noopener noreferrer" data-testid="footer-website-link" className="block text-[rgba(255,255,255,0.75)] hover:text-[var(--accent)] transition-colors duration-200">
          www.kinsfolkmortgage.com
        </a>
      </div>

      <div className="space-y-2 text-sm">
        <a href="/privacy-policy" data-testid="footer-privacy-link" className="block text-[rgba(255,255,255,0.75)] hover:text-[var(--accent)] transition-colors duration-200">
          Privacy Policy
        </a>
        <a href="/terms" data-testid="footer-terms-link" className="block text-[rgba(255,255,255,0.75)] hover:text-[var(--accent)] transition-colors duration-200">
          Terms
        </a>
        {/* Supplied black EHL mark inside a compact white tile — do not recolor or place on navy */}
        <div className="inline-block bg-white rounded-[4px] p-2.5 mt-4">
          <img
            src={CAMPAIGN.equalHousingLogo}
            alt="Equal Housing Lender"
            className="h-12 w-auto"
            loading="lazy"
          />
        </div>
      </div>
    </div>

    <div className="max-w-6xl mx-auto px-5 md:px-10 pb-10 text-left">
      {/* [[COMPLIANCE TO REVIEW — FINAL DISCLOSURE WORDING]] */}
      <p className="text-[11px] leading-relaxed text-[rgba(255,255,255,0.45)] border-t border-[var(--line)] pt-8 mb-6" data-testid="footer-disclosure">
        {disclosure}
      </p>
      <p className="font-mono text-[10px] tracking-[0.08em] text-[rgba(255,255,255,0.45)]" data-testid="footer-copyright">
        {COPYRIGHT_LINE}
      </p>
    </div>
  </footer>
);
